import React from "react";
import { Link } from "react-router-dom";
import { LinkCellProps } from "../types";

export const LinkCell: React.FC<LinkCellProps> = ({
  to,
  href,
  text,
  fallback = "Unknown",
  onClick,
  className = "",
}) => {
  const linkClassName = `font-medium text-sm text-brand-600 hover:text-brand-700 dark:text-brand-400 hover:underline ${className}`;

  if (onClick) {
    return (
      <button onClick={onClick} className={linkClassName}>
        {text || fallback}
      </button>
    );
  }

  if (to) {
    return (
      <Link to={to} className={linkClassName}>
        {text || fallback}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={linkClassName}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text || fallback}
      </a>
    );
  }

  return (
    <span className="font-medium text-gray-700 dark:text-gray-300">
      {text || fallback}
    </span>
  );
};
